import React, { useMemo, useRef, useState, useEffect } from "react";
import { Suspense } from "react";
import { useFrame, useLoader } from "@react-three/fiber";
import {
  useGLTF,
  Html,
  ContactShadows,
  PresentationControls,
  Float,
  Lightformer,
  MeshPortalMaterial,
  OrbitControls,
} from "@react-three/drei";
import { useTexture } from "@react-three/drei";
import { Perf } from "r3f-perf";
import { Sky, Environment } from "@react-three/drei";
import { useControls } from "leva";
import * as THREE from "three";

import "./style.css";
import Gameboy from "./Gameboy.jsx";
import Seeus from "./Seeus.jsx";
import Tree from "./Tree.jsx";

import dont from "../public/sound/dont.mp3";
import dontTwo from "../public/sound/dontTwo.mp3";
import img from "../public/texture/grass.jpg";

export default function Screen() {
  let startSound;
  const audio = new Audio();
  const htmlContent = ["!!? ", "!!!", "!!", "*#? ", "!??", "?#$", "*^$", "%#$"];

  const eventHandler = async (event) => {
    // console.log(event.object);

    if (!audio.paused) audio.pause();
    if (open) {
      audio.src = dont;
      await audio.play();
    } else {
      audio.src = dontTwo;
      await audio.play();
    }
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000); // Hide the Html component after 3 seconds
  };

  const [open, setOpen] = useState(false);
  const texture = useLoader(THREE.TextureLoader, img);

  const randomIndex = Math.floor(Math.random() * htmlContent.length);
  const selectedContent = htmlContent[randomIndex];

  return (
    <>
      {/* 1.3,1.1 */}

      <mesh position={[0, 1, 0.16]} rotation={[-6.14, 0, 0]}>
        <planeGeometry args={[1.3, 1.1]} height={[22]} />

        <MeshPortalMaterial>
          <Environment preset="park">
            <Lightformer
              position-z={-20}
              scale={20}
              color="white"
              intensity={50}
            />
          </Environment>

          {open && (
            <Html
              position={[0.2, 0.5, -2]}
              wrapperClass="label"
              distanceFactor={8}
            >
              {selectedContent}
            </Html>
          )}

          <Seeus
            scale={0.07}
            position={[0, 0, -1]}
            onClick={eventHandler}
            onPointerEnter={() => {
              document.body.style.cursor = "pointer";
            }}
            onPointerLeave={() => {
              document.body.style.cursor = "default";
            }}
          />

          <Tree
            scale={1.05}
            position={[0, -0.5, -1]}
            rotation={[0.2, 9, 0]}
          ></Tree>

          <mesh position={[0, -0.5, -1]} rotation={[-1.3, 0, 0]} scale={"10"}>
            <planeGeometry />
            <meshBasicMaterial attach="material" map={texture} />
          </mesh>
        </MeshPortalMaterial>
      </mesh>
    </>
  );
}
